
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tournaments/signup",
      function () {
        return require("private-next-pages/tournaments/signup.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tournaments/signup"])
      });
    }
  